// extracted by mini-css-extract-plugin
export default {"container":"resumePage_container__dhMwZ","content":"resumePage_content__cuVsZ"};